/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect } from "react";
import {
  Typography,
  makeStyles,
  Tooltip,
  Theme,
  withStyles,
  Card,
  CardContent,
  CardActions,
  Grid,
  Button
} from "@material-ui/core";
import { typography } from "material-ui/styles";
import { IconTooltip } from "../../icons/IconTooltip";
import { EditFieldHistoryComponent } from "./EditFieldHistoryComponent";

export const useStylesInputLocal = makeStyles(theme => ({
  iconInfo: {
    width: "16px !important",
    height: "16px !important",
    marginLeft: 20,
    color: "#32325d",
    "&:hover": {
      color: "#5e72e4"
    }
  },
  editedLabel: {
    width: "69px",
    height: "21px",
    alignItems: "center",
    borderRadius: "6px",
    backgroundColor: "#fb623f",
    marginRight: "10px",
    justifyContent: "space-between",
    display: "flex"
  },
  tagTitle: {
    fontSize: "10px",
    padding: "3px",
    paddingLeft: "10px",
    fontWeight: 600,
    color: "#ffffff"
  },
  root: {
    // minWidth: 275,
    // boxShadow: "none",
    //  padding: `${theme.spacing(3)}px ${theme.spacing(3)}px`,
    display: "flex",
    flexdirection: "column"
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  container: {
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    // boxShadow: "0 2px 12px 0 rgba(50, 50, 93, 0.21)",
    backgroundColor: "#ffffff"
    // marginTop: theme.spacing(3)
    // fontFamily: "OpenSans"
  },
  title: {
    fontFamily: "OpenSans",
    fontSize: "12px",
    fontWeight: 600,
    paddingLeft: "10px",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.58,
    width: "calc(100% - 38px)",
    letterSpacing: "normal",
    color: "#32325d"
  },
  orgClass: {
    display: "inline-block",
    color: "white",
    height: "20px",
    width: "20px",
    borderRadius: "50%",
    fontSize: "11px",
    textAlign: "center",
    backgroundImage:
      "linear-gradient(139deg, #0fcbef 2%, #1071ee 95%), linear-gradient(to bottom, #d8d8d8, #d8d8d8)"
  },
  latClass: {
    display: "inline-flex",
    color: "white",
    height: "20px",
    width: "20px",
    borderRadius: "50%",
    fontSize: "11px",
    textAlign: "center",
    backgroundImage:
      "linear-gradient(139deg, #0fcbef 2%, #1071ee 95%), linear-gradient(to bottom, #d8d8d8, #d8d8d8)",
    justifyContent: "center",
    alignItems: "center",
    lineHeight: "12px"
  },
  title2: {
    fontFamily: "OpenSans",
    fontSize: "12px",
    fontWeight: 600,
    // paddingLeft: "20px",
    marginLeft: "23px",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.58,
    letterSpacing: "normal",
    color: "#32325d"
  },
  title3: {
    fontFamily: "OpenSans",
    fontSize: "12px",
    fontWeight: 600,
    paddingLeft: "25px",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.58,
    letterSpacing: "normal",
    // color: "#32325d",
    marginBottom: "15px"
  },
  initials: {
    backgroundImage:
      "linear-gradient(139deg, #0fcbef 2%, #1071ee 95%), linear-gradient(to bottom, #d8d8d8, #d8d8d8)",
    height: "20px",
    width: "20px",
    display: "inline-flex",
    borderRadius: "50%",
    fontSize: "11px",
    textAlign: "center",
    color: "#ffffff",
    marginRight: "5px",
    justifyContent: "center",
    alignItems: "center",
    lineHeight: "12px"
  },
  Line: {
    width: "1px",
    height: "calc(100% - 18px)",
    border: "1px solid #5c70ec",
    position: "absolute",
    top: "20px",
    left: "25px",
    "&:first-child:": {
      top: "36px"
    }
  },

  pos: {
    marginBottom: 12
  },
  firstEdit: {
    marginTop: "15px"
  },
  oval: {
    width: "23px",
    height: "23px",
    backgroundColor: "#5c70ec",
    marginLeft: 15,
    borderRadius: "50%",
    textAlign: "center",
    position: "relative"
  },
  ellipses: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  infoContainer: {
    position: "relative"
  },
  infoInnerContainer: {
    paddingLeft: "24px"
  },
  reasonLabel: {
    margin: "5px 0"
  }
}));

export const HtmlTooltipLocal = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "white",
    width: "368px",
    maxWidth: "368px !important",
    boxShadow: "0 2px 12px 0 rgba(50, 50, 93, 0.21)",
    padding: "0px",
    fontSize: theme.typography.pxToRem(12)
    // border: "1px solid #dadde9",
  }
}))(Tooltip);

export interface ViewModeTextFieldProps {
  style?: React.CSSProperties;
  label: React.ReactNode;
  value: any;
  editedLabel?: any;
  editedData?: any[];
  isNotInfo?: boolean;
  isLATView?: boolean;
  key?: string;
  editComponent?: any;
  customTag?: any;
  infoIconData?: any;
  fromSummary?: any;
  requestWaiverProps?: any;
  viewtextStyles?: any;
  viewlabelStyles?: React.CSSProperties;
  showEditHistoryOnLine?: boolean;
  fromSettelement?: boolean;
  isServicerMandatory?: boolean;
  valueTestId?: string;
  renderCustomInfoTag?: any;
}

export function ViewModeTextField(props: ViewModeTextFieldProps) {
  const {
    style,
    label,
    value,
    editedLabel,
    infoIconData,
    isNotInfo,
    isLATView,
    editedData,
    editComponent,
    customTag,
    requestWaiverProps,
    fromSummary,
    viewtextStyles,
    showEditHistoryOnLine,
    fromSettelement,
    viewlabelStyles,
    isServicerMandatory,
    valueTestId,
    renderCustomInfoTag = () => <></>
  } = props;
  const classes = useStylesInputLocal();
  function doesntHaveInvalidString(str: any) {
    if (str !== null && str !== undefined && str !== "") {
      if (str && typeof str === "string") {
        const invalidStrings = [
          "null",
          "NaN",
          "Infinity",
          "undefined",
          "Error",
          "error"
        ];
        return !invalidStrings.some(el => str.includes(el));
      }
      return true;
    }
    return false;
  }
  // function formatDate(date: any) {
  //   if (date) {
  //     const dateAndTime = new Date(date).toLocaleDateString(undefined, {
  //       hour12: false, //AM-101
  //       hour: "2-digit",
  //       minute: "2-digit",
  //       year: "numeric",
  //       month: "short",
  //       day: "2-digit"
  //     });
  //     return dateAndTime;
  //   }
  //   return "";
  // }
  // function nameToInitials(fullName: string) {
  //   if (fullName) {
  //     const namesArray = fullName
  //       .trim()
  //       .toUpperCase()
  //       .split(" ");
  //     if (namesArray.length === 3) {
  //       return namesArray[0].charAt(0) + namesArray[2].charAt(0);
  //     }
  //     if (namesArray.length === 2) {
  //       return namesArray[0].charAt(0) + namesArray[1].charAt(0);
  //     }
  //     return namesArray[0].charAt(0);
  //   }
  //   return "";
  // }

  // const EditHistoryComponent = (propss: { auditList: any[] }) => {
  //   const { auditList } = propss;
  //   return (
  //     <>
  //       {auditList && auditList?.length > 0 && !isNotInfo ? (
  //         <div
  //           className={classes.editedLabel}
  //           style={fromSettelement ? { width: "auto" } : {}}
  //         >
  //           <div className={classes.tagTitle}>
  //             {fromSettelement &&
  //             auditList[0].updatedBy === "System Re-Calculated"
  //               ? "Recalc"
  //               : "Edited"}
  //           </div>
  //           <HtmlTooltipLocal
  //             placement={!fromSettelement ? "right-end" : undefined}
  //             // placement="right-end"
  //             // color="white"
  //             title={
  //               <>
  //                 <div className={classes.container}>
  //                   <Grid container spacing={3} className={classes.root}>
  //                     <Grid item xs={12} container>
  //                       <Grid item xs={6} sm={12}>
  //                         {auditList &&
  //                           auditList.map((item: any, index: any) => {
  //                             return (
  //                               <div
  //                                 key={`audit-${index}`}
  //                                 className={classes.infoContainer}
  //                               >
  //                                 <Grid
  //                                   item
  //                                   xs={1}
  //                                   sm={1}
  //                                   md={1}
  //                                   xl={1}
  //                                   style={{ display: "flex" }}
  //                                 >
  //                                   {index !== auditList.length - 1 &&
  //                                   auditList.length !== 1 &&
  //                                   index < 2 ? (
  //                                     <span className={classes.Line} />
  //                                   ) : (
  //                                     ""
  //                                   )}
  //                                 </Grid>
  //                                 <Grid
  //                                   container
  //                                   item
  //                                   xs={12}
  //                                   sm={12}
  //                                   md={12}
  //                                   xl={12}
  //                                   className={
  //                                     index === 0 ? classes.firstEdit : ""
  //                                   }
  //                                 >
  //                                   <span className={classes.oval}>
  //                                     <IconTooltip
  //                                       topic="Edit_white"
  //                                       infoIconData="edit"
  //                                     />
  //                                   </span>
  //                                   <Typography
  //                                     className={classes.title}
  //                                     color="textSecondary"
  //                                     gutterBottom
  //                                   >
  //                                     Previous Value :&nbsp;
  //                                     {item?.preValue === true
  //                                       ? "Yes"
  //                                       : item?.preValue === false
  //                                       ? "No"
  //                                       : typeof item?.preValue === "string" ||
  //                                         typeof item?.preValue === "number"
  //                                       ? item?.preValue
  //                                       : item?.preValue?.[0]}
  //                                   </Typography>
  //                                 </Grid>
  //                                 <Grid
  //                                   container
  //                                   item
  //                                   xs={12}
  //                                   sm={12}
  //                                   md={12}
  //                                   xl={12}
  //                                   style={{ marginTop: 0 }}
  //                                   className={classes.infoInnerContainer}
  //                                 >
  //                                   <Grid item xs={12} sm={12} md={12} xl={12}>
  //                                     <Typography
  //                                       component="div"
  //                                       className={
  //                                         index === auditList.length - 1
  //                                           ? classes.title2
  //                                           : classes.title2
  //                                       }
  //                                       color="textSecondary"
  //                                       gutterBottom
  //                                     >
  //                                       Edited Value :&nbsp;
  //                                       {typeof item?.value === "string"
  //                                         ? item?.value
  //                                         : item?.value}
  //                                       <br />
  //                                       {!item?.comment &&
  //                                       item?.comments !== "null" ? (
  //                                         <p className={classes.reasonLabel}>
  //                                           Reason:&nbsp;
  //                                           {item?.comments}
  //                                         </p>
  //                                       ) : (
  //                                         ""
  //                                       )}
  //                                     </Typography>
  //                                     <Typography
  //                                       component="div"
  //                                       className={classes.title3}
  //                                       style={{
  //                                         position: "relative"
  //                                       }}
  //                                       color="textPrimary"
  //                                     >
  //                                       <span className={classes.initials}>
  //                                         {nameToInitials(item?.updatedBy)}
  //                                       </span>
  //                                       {item?.updatedBy}
  //                                       &nbsp;
  //                                       <span
  //                                         className={
  //                                           !item?.comments
  //                                             ? classes.latClass
  //                                             : classes.orgClass
  //                                         }
  //                                       >
  //                                         {!item?.comments ? "T" : "O"}
  //                                       </span>
  //                                       <span
  //                                         style={{
  //                                           paddingLeft: "5px"
  //                                         }}
  //                                       >
  //                                         {formatDate(
  //                                           new Date(item?.updatedOn)
  //                                         )}
  //                                       </span>
  //                                     </Typography>
  //                                   </Grid>
  //                                 </Grid>
  //                               </div>
  //                             );
  //                           })}
  //                       </Grid>
  //                     </Grid>
  //                   </Grid>
  //                 </div>
  //               </>
  //             }
  //           >
  //             <InfoOutlinedIcon htmlColor="white" />
  //           </HtmlTooltipLocal>
  //         </div>
  //       ) : null}
  //     </>
  //   );
  // };
  const checkSingleWord: boolean =
    typeof value === "string" && value?.split(" ")?.length === 1;
  let showError: boolean =
    !doesntHaveInvalidString(value) && (isServicerMandatory ? true : false);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        borderRadius: 4,
        border: showError ? "solid 1px red" : "solid 1px #e9ecef",
        width: "100%",
        padding: "14px 16px 14px 12px",
        ...style
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between"
        }}
      >
        <Typography
          variant="h5"
          style={{
            fontSize: 12,
            color: "#32325d",
            ...viewlabelStyles
          }}
        >
          {label}
        </Typography>
        <div
          style={{
            justifyContent: "space-between",
            display: "flex",
            alignItems: "center"
          }}
        >
          {!showEditHistoryOnLine && editedData ? (
            <EditFieldHistoryComponent
              auditList={editedData}
              fromSettelement={fromSettelement}
              isNotInfo={isNotInfo}
            />
          ) : null}
          {customTag || null}
          {editComponent || null}
          {infoIconData &&
            <IconTooltip topic="Information" infoIconData={infoIconData} />
          }
          {
            renderCustomInfoTag()
          }
        </div>
      </div>
      <Grid container>
        <Grid
          item
          xs={requestWaiverProps?.showRequestWaiverButton ? 6 : 12}
          sm={12}
          md={requestWaiverProps?.showRequestWaiverButton ? 6 : 12}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <Typography
              component="div"
              title={
                ((label === "Address" || label === "Property Type") &&
                  fromSummary) ||
                  showEditHistoryOnLine
                  ? typeof value === "string"
                    ? value
                    : ""
                  : ""
              }
              className={
                fromSummary || checkSingleWord || fromSettelement
                  ? classes.ellipses
                  : ""
              }
              style={{
                fontSize: 14,
                color: "#32325d",
                marginTop: 10,
                ...viewtextStyles
              }}
              data-testid={valueTestId}
            >
              {doesntHaveInvalidString(value) ? value : <span>&#8213;</span>}
            </Typography>
            {showEditHistoryOnLine && editedData ? (
              <div>
                <EditFieldHistoryComponent auditList={editedData} />
              </div>
            ) : null}
          </div>
        </Grid>
        {requestWaiverProps?.showRequestWaiverButton && (
          <Grid item xs={6} sm={12} md={6}>
            <Button
              variant="contained"
              size="small"
              data-testid="request-waiver-btn"
              disabled={requestWaiverProps?.disableRequestWaiver}
              onClick={() => requestWaiverProps?.onRequestWaiverClick()}
              style={{
                borderRadius: "4px",
                boxShadow: "1px 2px 2px 0 rgba(0, 0, 0, 0.24)",
                backgroundColor: "#5e72e4",
                position: "absolute",
                right: "24px"
              }}
            >
              Request waiver
            </Button>
          </Grid>
        )}
      </Grid>
    </div>
  );
}
